"use strict";

//Chargement et ouverture de la colonne de détail d'une demande
$.fn.loadDemandeArticleDetail = function (id) {
    var $target = $(this);
    var params = $.param({
        id: id
    });
    $target.load("/Article/GetDetailArticle?" + params, function (data) {
        $target.parents(".row-articles").addClass("col-detail-open");
    });
    return $target;
};
$.select2DataCustomFilter = function ($el) {
    return {
        ajax: {
            url: $el.data("ajax-url"),
            dataType: 'json',
            data: function data(params) {
                return {
                    q: params.term,
                    term: params.term,
                    anneeMarche: $(".custom-filter-container select[data-column=IdMarche]").val(),
                    chapter: $(".custom-filter-container select[data-column=Chapitre]").val(),
                    ssChapter: $(".custom-filter-container select[data-column=SsChapitre]").val()
                };
            }
        }
    };
};
$.datatablesTemplates.push({
    name: "serie-prix",
    callback: function callback(data) {
        return "<div class=\"custom-control custom-checkbox custom-control-inline\" style=\"padding-left: 1rem;\">\n            <input type=\"checkbox\" id=\"Serie-prix\" class=\"custom-control-input\"\n            " + (data.SeriePrix ? "checked" : "") + " disabled>\n            <label class=\"custom-control-label\" for=\"Serie-prix\"></label>\n            </div>";
    }
});
$.fn.getUrlForFilter = function () {
    var url = $(this).data("ajax-url");
    var params = $.param({});
    return url + "&" + params;
};
$(function () {
    var $articleContainer = $("div.row-articles");
    //Si on est sur la page, on l'initialise
    if ($articleContainer.length > 0) {
        var $datatableDiv = $articleContainer.find("div.datatable");
        var toggleActionFilter = function toggleActionFilter(toggle) {
            var $btn = $(".btn-toggle-filtre");
            $btn.toggleClass("bg-filter-show", toggle).data("show", toggle);
            $("thead tr:not(:first)", $datatableDiv).toggle(toggle);
            $(".btn-article-unfilter").toggle(toggle);
            $articleContainer.find(".custom-filter-container").toggle(toggle);
        };
        var updateFilter = function updateFilter($select, valueToCompare) {
            if ($select.val() && $select.val().substr(0, valueToCompare.length) !== valueToCompare) {
                var datatable = $datatableDiv.data("datatable");
                //On vide le select 2
                $select.html("");
                //On vide les valeurs de recherche de la colonne datatable
                var column = datatable.columns($select.data("column") + ":name");
                column.search("");
            }
        };
        $(document)
        //On montre ou on masque filtres
        .on("click", ".btn-toggle-filtre", function () {
            var $this = $(this);
            toggleActionFilter(!$this.data("show"));
            $this.blur();
        })
        //Fermeture de la colonne de détail de la demande
        .on("click", ".col-details .detail-header .col-actions i.fa-times", function () {
            $(this).parents(".row-articles").removeClass("col-detail-open");
            $("tr.detail-show").removeClass("detail-show");
        })
        //Chargement du détail d'une demande
        .on("click", "div.row-articles div.datatable table tbody tr", function () {
            var $this = $(this),
                $target = $this.parents("div.col-list").next(),
                id = $this.data("article-id");
            $("tr.detail-show").removeClass("detail-show");
            $this.addClass("detail-show");
            $target.loadDemandeArticleDetail(id);
        }).on("click", ".btn-article-unfilter", function () {
            var datatable = $datatableDiv.data("datatable");
            $("div.custom-filter-container").find(".datatable-filter-custom.datatable-filter-select2").each(function () {
                var $filter = $(this).html("");
                var column = datatable.columns($filter.data("column") + ":name");
                column.search("");
                $(column.header()[0]).removeClass("filtered");
                var columDisplayName = $filter.data("column-display");
                if (columDisplayName && columDisplayName !== $filter.data("column")) {
                    $(datatable.columns(columDisplayName + ":name").header()[0]).removeClass("filtered");
                }
            });
            $("div.datatable table thead tr th button.unfilter").trigger("click");
            $(this).blur();
        }).on("change", "#custom-filter-valid", function () {
            var customVar = $datatableDiv.data("customVars");
            customVar = $.extend(customVar, {
                articleValid: $(this).is(":checked")
            });
            $datatableDiv.data("datatable").draw();
        });
        $(".btn-go-filter").on("click", function () {
            var $this = $(this),
                datatable = $datatableDiv.data("datatable"),
                column = datatable.columns($this.data("column") + ":name");
            column.search($this.prev().val());
            datatable.draw();
        });
        $datatableDiv.on("draw", function () {
            if ($articleContainer.hasClass("col-detail-open")) {
                var $colDetail = $("div.col-details");
                var idDetail = $colDetail.find("input#demandeId").val();
                if (!idDetail || idDetail == 0 || idDetail === "") {
                    $articleContainer.removeClass("col-detail-open");
                } else {
                    $("tbody tr[data-demande-id=" + idDetail + "]").addClass("detail-show");
                    $colDetail.loadDemandeArticleDetail(idDetail);
                }
            }
            var $btnShowFilter = $(".btn-toggle-filtre");
            if (!$btnShowFilter.data("show")) {
                toggleActionFilter(false);
            }
        }).on("createdRow", function (e, row, data) {
            var $row = $(row);
            var id = data["IdArticle"];
            $row.attr("data-article-id", id);
        }).on("filter-change", function (e, extraParameters) {
            if (extraParameters && extraParameters && extraParameters.source === "custom-filter-select2.change") {
                var $this = extraParameters.control;
                var value = $this.val();
                if (!value || value === "") {
                    return;
                }
                var selectToUpdate = $this.data("select-to-update");
                if (selectToUpdate && selectToUpdate !== "[]") {
                    selectToUpdate.map(function (el) {
                        return updateFilter($("select[data-column=" + el + "]"), value);
                    });
                }
                $datatableDiv.data("datatable").draw();
            }
        }).setDatatable();
        // setTimeout(() => {
        //     const $trs = $datatableDiv.find("thead tr"),
        //         $tr = $($trs[0]),
        //         $trFilter = $($trs[1]);
        //    
        //     $trFilter.find("th").removeClass("sorting");
        //     $tr.find("th").on("click", function() {
        //         $trFilter.find(`th[data-column=${$(this).data("column")}]`).trigger("click");
        //     });
        // }, 300);
    }
});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Article/index.ts
// module id = 614
// module chunks = 0